
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useDroppable } from '@dnd-kit/core';
import { Task } from '@/types/task';
import { KanbanTaskCard } from './KanbanTaskCard';

interface KanbanColumnProps {
  id: string; // will be status
  title: string;
  tasks: Task[];
  onTaskClick: (task: Task) => void;
}

export const KanbanColumn = ({ id, title, tasks, onTaskClick }: KanbanColumnProps) => {
  const { setNodeRef } = useDroppable({ id });
  const taskIds = tasks.map(task => task.id);

  return (
    <div className="w-80 flex-shrink-0 bg-slate-100/60 rounded-lg flex flex-col max-h-[calc(100vh-22rem)]">
      <h3 className="font-semibold p-3 sticky top-0 bg-slate-100/80 backdrop-blur-sm z-10 border-b">
        {title} <span className="text-sm text-slate-500 font-normal">{tasks.length}</span>
      </h3>
      <SortableContext id={id} items={taskIds} strategy={verticalListSortingStrategy}>
        <div ref={setNodeRef} className="space-y-3 p-3 overflow-y-auto flex-grow">
          {tasks.map(task => (
            <KanbanTaskCard key={task.id} task={task} onClick={() => onTaskClick(task)} />
          ))}
          {tasks.length === 0 && (
            <div className="flex items-center justify-center h-full text-center p-4 border-2 border-dashed border-slate-200 rounded-md">
              <p className="text-slate-400 text-sm">اسحب المهام إلى هنا</p>
            </div>
          )}
        </div>
      </SortableContext>
    </div>
  );
};
